import { YDeferred } from '../y/types';
import { yDefer } from '../y/util';
import { UIPresentationOptions, uiDismissView, uiPresent } from './present';
import { UIClassesSpec } from './types';
import { UIView } from './view';

export interface UIAsideOptions {
    tap_close?: boolean;
}

export interface UIAsidePresentationOptions extends UIPresentationOptions {
    replace?: UIAside<any>;
}

export class UIAside<T = boolean> extends UIView {
    private _deferred?: YDeferred<T>;
    private _tap_close?: boolean;
    private _dismissed?: boolean;

    constructor(classes: UIClassesSpec, options: UIAsideOptions = {}) {
        super('aside', classes);

        this._tap_close = options.tap_close;
    }

    present(options?: UIAsidePresentationOptions) {
        options = Object.assign({ backdrop_kind: 'dark', position: 'center' }, options);

        if(this._tap_close)
            options.on_click = () => { this.dismiss(null); };

        if(options.replace)
            options.replace._dismissed = true;

        uiPresent(this, options);

        this._deferred = yDefer<T>();
        return this._deferred.promise;
    }

    dismiss(value: T | Promise<T> | null) {
        if(value === null)
            this._deferred!.reject();
        else
            this._deferred!.resolve(value);

        if(!this._dismissed) {
            this._dismissed = true;
            uiDismissView(this);
        }
    }
}
